import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useSearchParams } from 'react-router-dom';
import { CaptureThemesPanel } from '../../CaptureThemesPanel';
import { usePursuitRecord } from '../PursuitRecordContext';
import { PursuitSectionFrame } from '../PursuitSectionFrame';
import { CustomerTabs } from './CustomerSection';
/**
 * Customer themes (`customer/themes`, legacy `?tab=themes`). The People tab
 * already shows the stakeholders, so the panel hides its own copy.
 */ export function CustomerThemesSection() {
    const { captureProjectId, correlationId } = usePursuitRecord();
    // GRW-30: sections always sit in the record shell, so the gate is the header capabilities.
    const { canEdit } = usePursuitRecord().capabilities;
    const [params] = useSearchParams();
    const pinnedThemeId = params.get('overviewKind') === 'theme' ? params.get('overviewId') ?? undefined : undefined;
    return /*#__PURE__*/ _jsxs(PursuitSectionFrame, {
        title: "Customer & touchpoints",
        children: [
            /*#__PURE__*/ _jsx(CustomerTabs, {
                value: "themes"
            }),
            /*#__PURE__*/ _jsx(CaptureThemesPanel, {
                readOnly: !canEdit,
                captureProjectId: captureProjectId,
                correlationId: correlationId,
                hideStakeholders: true,
                pinnedThemeId: pinnedThemeId,
                pinnedVersionId: params.get('themeVersion') ?? undefined
            })
        ]
    });
}
